import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchActiveTournaments } from '../actions';
import TournamentTile from './TournamentTile';
import NavigationBar from './NavigationBar';
import {typeFilters, rankFilters, locationFilters, sortingModes} from '../utils/tournaments';


class TournamentList extends Component {

  pageSize = 10;

  noFilterInfo = 'Wszystkie';

  componentDidMount() {
    const { dispatch } = this.props;
    this.state = { offset: 0, limit: this.pageSize };
    this.previousPage = this.previousPage.bind(this);
    this.nextPage = this.nextPage.bind(this);
    dispatch(fetchActiveTournaments(this.state));
  }

  updateFilter(filterChange) {
    return (evt) => {
      const { dispatch } = this.props;
      const newState = {...this.state, ...filterChange};
      this.setState(newState);
      dispatch(fetchActiveTournaments(newState));
    };
  }

  previousPage() {
    const { dispatch } = this.props;
    const newOffset = this.state.offset - this.state.limit;

    if (newOffset >= 0) {
      const newState = {...this.state, offset: newOffset};
      this.setState(newState);
      dispatch(fetchActiveTournaments(newState));
    }
  }

  nextPage() {
    if (this.props.tournaments && this.props.tournaments.length > 0) {
      const { dispatch } = this.props;
      const newOffset = this.state.offset + this.state.limit;

      const newState = {...this.state, offset: newOffset};
      this.setState(newState);
      dispatch(fetchActiveTournaments(newState));
    }
  }

  render() {

    const { t, i18n } = this.props;

    return (
      <div>
        <NavigationBar />
        <div className="container col-md-6">
          <h1>{t('tournamentList.title')}</h1>
          <div className="d-flex justify-content-between">
            <div className="d-inline-block">
              <div className="dropdown d-inline-block ml-2 mr-2 mt-1 mb-1">
                <span className="mr-1">Typ:</span>
                <button className="btn btn-sm btn-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {(this.state && this.state.type) ? typeFilters[this.state.type] : this.noFilterInfo}
                </button>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a className="dropdown-item" href="#" onClick={this.updateFilter({type: undefined})}>{this.noFilterInfo}</a>
                  {
                    Object.keys(typeFilters).map(value => {
                      return (<a className="dropdown-item" href="#" onClick={this.updateFilter({type: value})}>{typeFilters[value]}</a>);
                    })
                  }
                </div>
              </div>
              <div className="dropdown d-inline-block ml-2 mr-2 mt-1 mb-1">
                <span className="mr-1">Ranga:</span>
                <button className="btn btn-sm btn-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {(this.state && this.state.rank) ? rankFilters[this.state.rank] : this.noFilterInfo}
                </button>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a className="dropdown-item" href="#" onClick={this.updateFilter({rank: undefined})}>{this.noFilterInfo}</a>
                  {
                    Object.keys(rankFilters).map(value => {
                      return (<a className="dropdown-item" href="#" onClick={this.updateFilter({rank: value})}>{rankFilters[value]}</a>);
                    })
                  }
                </div>
              </div>
              <div className="dropdown d-inline-block ml-2 mr-2 mt-1 mb-1">
                <span className="mr-1">Lokalizacja:</span>
                <button className="btn btn-sm btn-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {(this.state && this.state.location) ? locationFilters[this.state.location] : this.noFilterInfo}
                </button>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a className="dropdown-item" href="#" onClick={this.updateFilter({location: undefined})}>{this.noFilterInfo}</a>
                  {
                    Object.keys(locationFilters).map(value => {
                      return (<a className="dropdown-item" href="#" onClick={this.updateFilter({location: value})}>{locationFilters[value]}</a>);
                    })
                  }
                </div>
              </div>
              <div className="dropdown d-inline-block ml-2 mr-2 mt-1 mb-1">
                <span className="mr-1">Sortowanie:</span>
                <button className="btn btn-sm btn-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {(this.state && this.state.sortingMode) ? sortingModes[this.state.sortingMode] : sortingModes['START_TIME_ASCENDING']}
                </button>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  {
                    Object.keys(sortingModes).map(value => {
                      return (<a className="dropdown-item" href="#" onClick={this.updateFilter({sortingMode: value})}>{sortingModes[value]}</a>);
                    })
                  }
                </div>
              </div>
            </div>
            <div className="d-inline-block text-nowrap">
                <button className="btn btn-sm" onClick={this.previousPage}>&lt;</button>
                <span className="ml-1 mr-1">{ this.state ? this.state.offset + 1 : '' }-{ this.state ? this.state.offset + this.state.limit : '' }</span>
                <button className="btn btn-sm" onClick={this.nextPage}>&gt;</button>
            </div>
          </div>
          {
            (this.props.tournaments && this.props.tournaments.length > 0) ?
              (this.props.tournaments.map(tournament =>
                <TournamentTile tournament={tournament}></TournamentTile>
              )) : <div className="text-center">Brak turniejów do wyświetlenia.</div>
          }
        </div>
      </div>
    );
  }
}

TournamentList.propTypes = {
  tournaments: PropTypes.array,
  dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return { tournaments: state.tournaments };
}

export default translate('translations')(connect(mapStateToProps)(TournamentList));



// WEBPACK FOOTER //
// ./components/TournamentList.js